import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "kt_drawer_unique_course",
  "data-kt-drawer": "true",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-name": "course_term",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#kt_drawer_unique_course_button",
  "data-kt-drawer-close": "#kt_drawer_unique_course_close",
  "data-kt-drawer-width": "75.5vw"
}
const _hoisted_2 = {
  id: "kt_unique_course",
  class: "card shadow-none border-0",
  style: {"width":"72.5vw"}
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header bg-primary text-light\" id=\"kt_unique_course_header\"><h3 class=\"card-title fw-bolder text-light\" style=\"font-size:1.35rem !important;\"> Unique Course : </h3><div class=\"card-toolbar\"><button type=\"button\" class=\"btn btn-sm btn-icon btn-active-primary-light me-n5\" id=\"kt_drawer_unique_course_close\"><i class=\"fas fa-times text-light\"></i></button></div></div>", 1)
const _hoisted_4 = {
  class: "card-body position-relative",
  id: "kt_unique_course_body",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-wrappers": "#kt_unique_course_body",
  "data-kt-scroll-dependencies": "#kt_unique_course_header, #kt_unique_course_footer",
  "data-kt-scroll-offset": "5px"
}
const _hoisted_5 = { class: "position-relative" }
const _hoisted_6 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 bg-success cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#unique-course",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Course Name")
  ])
], -1)
const _hoisted_8 = {
  id: "unique-course",
  class: "collapse show"
}
const _hoisted_9 = { class: "collapse show" }
const _hoisted_10 = { class: "card-body border-top p-9" }
const _hoisted_11 = {
  class: "table",
  style: {"border":"1.5px solid #23ce10"}
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("thead", { style: {"border-left":"1.5px solid #23ce10"} }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Sl"),
    /*#__PURE__*/_createElementVNode("th", null, "Course"),
    /*#__PURE__*/_createElementVNode("th", null, "Tranche"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Partner"),
    /*#__PURE__*/_createElementVNode("th", null, "Code"),
    /*#__PURE__*/_createElementVNode("th", null, "Duration(months)"),
    /*#__PURE__*/_createElementVNode("th", null, "Unit Cost"),
    /*#__PURE__*/_createElementVNode("th", null, "Category"),
    /*#__PURE__*/_createElementVNode("th", null, "Training Type")
  ])
], -1)
const _hoisted_13 = { style: {"border-left":"1.5px solid #23ce10"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("table", _hoisted_11, [
                    _hoisted_12,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.unique_course_details, (data, index) => {
                      return (_openBlock(), _createElementBlock("tbody", { key: index }, [
                        _createElementVNode("tr", _hoisted_13, [
                          _createElementVNode("td", null, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.course_name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.tranche_data
                              ?.short_name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.entities
                              ?.entity_short_name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.code), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.month), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.unit_cost_total), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.course_category?.name), 1),
                          _createElementVNode("td", null, _toDisplayString(_ctx.unique_course_details[index]?.course_type_info
                              ?.course_parent_type?.type_name), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ])
  ])), [
    [_directive_loading, _ctx.load]
  ])
}